module.exports = __webpack_public_path__ + "static/media/unsplash_AbnCRgL2DNs.04d6ad81.jpg";